





















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import {
  GetZiliaoList,
  EditZiliao,
  DelZiliao,
  UploadFile,
} from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            ziliao_id: item.ziliao_id,
          },
        };
        DelZiliao(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功！");
            this.search();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        // res.full_file_url
        const d: any = {
          file_url: res.full_file_url,
          名称: file.file.name,
        };
        this.saveZiliao(d);
      })
      .catch(() => {
        loading.close();
      });
  }
  private editUpload(file: any, item: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        // res.full_file_url
        item["名称"] = file.file.name;
        item["file_url"] = res.full_file_url;
        this.saveZiliao(item);
      })
      .catch(() => {
        loading.close();
      });
  }
  private saveZiliao(d: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditZiliao(this, d, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("上传成功");
        this.search();
      })
      .catch(() => {
        loading.close();
      });
  }
  private beforeAvatarUpload(file: any) {
    const isLt100M = file.size / 1024 / 1024 < 100;

    if (!isLt100M) {
      this.$message.error("上传文件大小不能超过100MB!");
    }
    return isLt100M;
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    GetZiliaoList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    this.getList();
  }
}
